import React, { useEffect, useState } from "react";
import { getGroupsForSuperUser, postNeuenMieter } from "../api";
import Animation from "../components/Animation";

function CreateMieterPage() {
  const [loading, isLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [formData, setFormData] = useState({
    user: "",
    name: "",
    email: "",
    password: "",
    street: "",
    postal_code: "",
    city: "",
    handy_number: "",
    einzugsdatum: "",
    auszugsdatum: ""
  });

  const requiredFields = ["user", "name", "email", "password"];

  useEffect(() => {
    const fetchUsers = async () => {
      const token = localStorage.getItem("token");
      try {
        const result = await getGroupsForSuperUser(token);
        setUsers(result);
      } catch (error) {
        console.error("Fehler beim Laden der Benutzer:", error);
      }
    };
    fetchUsers();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
    isLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    if (!formData.user || !formData.name || !formData.email || !formData.password) {
      alert("Bitte füllen Sie alle Pflichtfelder aus.");
      return;
    }

    try {
      await postNeuenMieter(formData, token);
      alert("Mieter erfolgreich erstellt!");
      setFormData({
        user: "",
        name: "",
        email: "",
        password: "",
        street: "",
        postal_code: "",
        city: "",
        handy_number: "",
        einzugsdatum: "",
        auszugsdatum: ""
      });
    } catch (error) {
      console.error("Fehler beim Erstellen des Mieters:", error);
      alert("Erstellen fehlgeschlagen. Bitte versuchen Sie es erneut.");
    }finally{isLoading(false)}
  };

  return (
    <div style={{ padding: "20px", maxWidth: "600px", margin: "auto" }}>
      <h2>Neuen Mieter erstellen</h2>
      <div className="form-container">
      <form onSubmit={handleSubmit}>
        {/* User select */}
        <div style={{ marginBottom: "10px" }}>
          <label>
            User auswählen <span style={{ color: "black" }}>*</span>:
          </label>
          <select name="user" value={formData.user} onChange={handleChange} required>
            <option value="">-- bitte wählen --</option>
            {users.map((user) => (
              <option key={user.id} value={user.id}>{user.username}</option>
            ))}
          </select>
        </div>

        {/* Other fields */}
        {Object.entries(formData).filter(([key]) => key !== "user").map(([key, value]) => (
          <div key={key} style={{ marginBottom: "10px" }}>
            <label>
              {key.charAt(0).toUpperCase() + key.slice(1).replace("_", " ")}
              {requiredFields.includes(key) && <span style={{ color: "black" }}> *</span>}:
            </label>
            <input
              type={key.includes("datum") ? "date" : key === "password" ? "password" : "text"}
              name={key}
              value={value}
              onChange={handleChange}
              required={requiredFields.includes(key)}
            />
          </div>
        ))}

        <p style={{ fontSize: "12px", color: "black" }}>
          <span style={{ color: "black" }}>*</span> Pflichtfeld
        </p>

        <button type="submit">Erstellen</button>
      </form>
      </div>
        <Animation loading={loading}/>
    </div>
  );
}

export default CreateMieterPage;
